export const MODE_TYPES = {
  d: 'd',
  pda: 'pda',
  pdm: 'pdm',
  pba: 'pba',
  pbm: 'pbm'
}

export const MODE_DEFAULT = MODE_TYPES.pba

// Authoring-time mode names, as the question format spells them.
export const MODE_CONVERSION_CHART = {
  popularity: MODE_TYPES.d,
  intensity_pairs: MODE_TYPES.pba,
  intensity_deltas: MODE_TYPES.pda
}

export const NEUTRAL_DEFAULT = 0

export const SETTINGS = {
  chartMargin: 60, // above the first row and below the last
  barMargin: 5, // around each bar, and the width of the central divider between the poles
  barHeight: 30,
  barRadius: 15, // barHeight / 2, so tracks and bar caps read as pills
  poleLabelGap: 20, // between a pole-label gutter and the track
  poleLabelWidth: 130 // the gutter a pole label is laid out in, one either side of the track
}

export const LABEL_COLORS = {
  default: '#333333',
  disabled: '#d5d5d5'
}
